import { render, staticRenderFns } from "./ContactInput.vue?vue&type=template&id=36ae095a&"
import script from "./ContactInput.vue?vue&type=script&lang=ts&"
export * from "./ContactInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports